//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import TransferListView from '@/views/Warehouse/WhTransferBetweenWarehouse/list'
import TransferCreateView from '@/views/Warehouse/WhTransferBetweenWarehouse/create'
import TransferDispatchView from '@/views/Warehouse/WhTransferBetweenWarehouse/dispatch'
import TransferReceptionView from '@/views/Warehouse/WhTransferBetweenWarehouse/reception'
import TransferReservationView from '@/views/Warehouse/WhTransferBetweenWarehouse/reservation'
import TransferUpdateView from '@/views/Warehouse/WhTransferBetweenWarehouse/update'

//
export default {
    path: 'transfers_between_warehouses',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'transfer-between-warehouse',
            component: TransferListView,
        },
        {
            path: 'create',
            name: 'transfer-between-warehouse-create',
            component: TransferCreateView,
            meta: {
                title: 'Crear guía de intercambio',
            },
        },
        {
            path: 'reservation',
            name: 'transfer-between-warehouse-reservation',
            component: TransferReservationView,
            meta: {
                title: 'Generadas por venta en terreno o call center',
            },
        },
        {
            path: ':id',
            name: 'transfer-between-warehouse-update',
            component: TransferUpdateView,
            meta: {
                title: 'Datos de guía de intercambio',
            },
        },
        {
            path: ':id/dispatch',
            name: 'transfer-between-warehouse-dispatch',
            component: TransferDispatchView,
            meta: {
                title: 'Despacho de guía de intercambio',
            },
        },
        {
            path: ':id/reception',
            name: 'transfer-between-warehouse-reception',
            component: TransferReceptionView,
            meta: {
                title: 'Recepción de guía de intercambio',
            },
        },
    ],
    meta: {
        title: 'Guías de intercambio',
    },
}
